import { HTTPService, httpService } from "../../core/services/http.service"
import { NewsDO } from "../data/news.data"

export class NewsService {
  private startDate: string
  private endDate: string
  private topK: number
  private minScore: number

  constructor(private httpService: HTTPService) {
    this.startDate = new Date(Date.now() - 1000 * 60 * 60 * 24 * 30).toISOString().split('T')[0]
    this.endDate = new Date().toISOString().split('T')[0]
    this.topK = 100
    this.minScore = 0
  }

  async load(query?: string | null, tokens?: string | null, title?: string | null): Promise<NewsDO[]> {
    const params = new URLSearchParams()

    params.set('top_k', this.topK.toString())
    params.set('min_score', this.minScore.toString())
    params.set('start_date', this.startDate)
    params.set('end_date', this.endDate)
    
    if (query) params.set('query', query)
    if (tokens) params.set('tokens', tokens)
    if (title) params.set('title', title)

    return await this.httpService.query(`articles?${params}`, "GET")
  }
}

export const newsService = new NewsService(httpService)